import ToggleBtn from "components/button/toggle";
import { langs } from "components/utils/option";
import { langProps } from "interface/index";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import useMultiLangStore from "store/multiLang";
import { getFormData } from "components/utils/comm";
import "./formHead.scss";

type IProps = {
  title: string;
  sub?: string;
  formId: string;
  savedLangs: string[]; // 등록된 언어
  btnTxt?: string;
  visible?: boolean;
  setBasetInf: (langCd: string, formData: any) => void;
  editedLang: () => Array<string>;
};

export default function MultiForm({
  title,
  sub,
  formId,
  visible,
  btnTxt,
  savedLangs,
  setBasetInf,
  editedLang,
}: IProps) {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const setMultiLang = useMultiLangStore((state) => state.setMultiLang);

  return (
    <>
      <div className="sub-head">
        <ul className="">
          <li className="flex items-center gap-2">
            <h3>{title}</h3>
            <sub className={sub ? "text-red-600 font-bold" : "hidden"}>
              {sub}
            </sub>
          </li>
          <li>
            <div className="flex gap-2">
              {langs.map((lang) => {
                // 버튼 상태값 설정 : 저장 , 입력 중
                const disabled =
                  savedLangs.includes(lang.code) && formId.includes("create");
                const status = editedLang().includes(lang.code)
                  ? "editing"
                  : disabled
                  ? "done"
                  : "empty";

                return (
                  <button
                    key={lang.code}
                    type="button"
                    form={formId}
                    disabled={disabled}
                    className={`btn status `}
                    onClick={(e) => {
                      /**
                       * 이미 등록된 언어일때 editing able, 전 폼의 createData || updateData 저장
                       * 미등록된 언어일때 등록폼 추가, 전 폼의 createData || updateData 저장
                       * langcd null일때 처음 클릭, langcd savedLangs이면 등록된 폼,
                       *
                       */

                      let langCd = formId.replace(/^.*-/, "");
                      const form = e.currentTarget.form as HTMLFormElement;

                      const createData = getFormData({ form, type: "C" });
                      const updateData = getFormData({ form, type: "U" });

                      const formData = langCd
                        ? savedLangs.includes(langCd)
                          ? updateData
                          : createData
                        : null;
                      setBasetInf(langCd ?? "", formData);
                      setMultiLang(lang.code);
                    }}
                  >
                    [
                    <span className={status} />
                    <span className="">{lang[langCd as keyof langProps]}</span>]
                  </button>
                );
              })}
            </div>
          </li>

          <li className="flex items-center gap-2">
            <button
              type="submit"
              form={formId}
              hidden={!visible}
              className="btn text-white bg-red-400"
            >
              {t(btnTxt)}
            </button>
            <ToggleBtn />
          </li>
        </ul>
      </div>
    </>
  );
}
